import { get as lodashGet } from "lodash-es";
import { useSearchStore } from "../store/useSearchStore";
import { DEFAULT_SEARCH_CATEGORIES } from "../GlobalSearchWithSDO.constants";
import type { SearchCategory } from "../GlobalSearchWithSDO.types";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

export const useDefaultSearchCategoriesData = () => {
  const { data: config } = useInstanceConfigQuery();
  const defaultSearchCategories: string[] = lodashGet(
    config,
    "es_configuration.client_config.default_search_categories",
    []
  );

  return defaultSearchCategories;
};

export const useDefaultSearchCategories = () => {
  const {
    setSelectedCategories,
    hasSelectedCategories,
    setHasSelectedCategories
  } = useSearchStore();

  const defaultSearchCategories = useDefaultSearchCategoriesData();

  if (!hasSelectedCategories) {
    const searchCategories =
      defaultSearchCategories.length > 0
        ? defaultSearchCategories
        : DEFAULT_SEARCH_CATEGORIES;
    setSelectedCategories(searchCategories as SearchCategory[]);
    setHasSelectedCategories(true);
  }
};
